export const ACTION_TYPES = {
  SET_RESULTS_COUNT_TOTAL: 'SET_RESULTS_COUNT_TOTAL',
  SET_LIST_COUNT: 'SET_LIST_COUNT',
  SET_SELECTED_RESULT_HEADER: 'SET_SELECTED_RESULT_HEADER',
  GET_RESULT_HOTELS: 'GET_RESULT_HOTELS',
  GET_RESULT_HOTELS_ERROR: 'GET_RESULT_HOTELS_ERROR',
  GET_RESULT_HOTELS_SUCCESS: 'GET_RESULT_HOTELS_SUCCESS',
  GET_RESULT_DESTINATIONS: 'GET_RESULT_DESTINATIONS',
  GET_RESULT_DESTINATIONS_ERROR: 'GET_RESULT_DESTINATIONS_ERROR',
  GET_RESULT_DESTINATIONS_SUCCESS: 'GET_RESULT_DESTINATIONS_SUCCESS',
  GET_RESULT_EXCURSIONS: 'GET_RESULT_EXCURSIONS',
  GET_RESULT_EXCURSIONS_ERROR: 'GET_RESULT_EXCURSIONS_ERROR',
  GET_RESULT_EXCURSIONS_SUCCESS: 'GET_RESULT_EXCURSIONS_SUCCESS',
  GET_RESULT_GROUP_TRIPS: 'GET_RESULT_GROUP_TRIPS',
  GET_RESULT_GROUP_TRIPS_ERROR: 'GET_RESULT_GROUP_TRIPS_ERROR',
  GET_RESULT_GROUP_TRIPS_SUCCESS: 'GET_RESULT_GROUP_TRIPS_SUCCESS',
  GET_RESULT_ALL: 'GET_RESULT_ALL',
  GET_RESULT_ALL_ERROR: 'GET_RESULT_ALL_ERROR',
  GET_RESULT_ALL_SUCCESS: 'GET_RESULT_ALL_SUCCESS',
  SET_NEVER_SHOW_REMINDER: 'SET_NEVER_SHOW_REMINDER',
  SET_SERIALIZED_COMPONENT: 'SET_SERIALIZED_COMPONENT',
  GET_RESULT_SERIALIZED_COMPONENTS: 'GET_RESULT_SERIALIZED_COMPONENTS',
};
